import React, { useState } from 'react';

import ReactPlayer from 'react-player';
import axios from 'axios';

import Warning from 'jsx/elements/messages/Warning';
import Button from 'jsx/elements/buttons/Button';
import Section from 'jsx/elements/section/Section';
import Flex from 'jsx/layout/Flex';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

const img = 'https://www.creditinfo.is/resources/images/icon/svg/bl-monitor-risk.svg';
const API_URL = process.env.REACT_APP_PORTFOLIO_API_URL;
const SEND_PATH = API_URL + '/communication/productinterest/291';

export default function Promo() {
  const [status, setStatus] = useState('initial');
  const { t } = useLocale();

  const videoUrl = t('portfolio_promo_video_url');

  async function send() {
    setStatus('sending');
    const res = await axios.get(SEND_PATH);
    if (res.status === 200 && res.data.sent === true) {
      setStatus('sent');
    } else {
      setStatus('error');
    }
  }

  function messageForStatus() {
    switch (status) {
      case 'initial':
        return <Warning messageType="alert" messageHeader={t('portfolio_promo_alert_header')} />;
      case 'sent':
        return (
          <Warning messageType="success" messageHeader={t('portfolio_promo_success_header')} />
        );
      case 'error':
        return <Warning messageType="error" messageHeader={t('portfolio_promo_error_header')} />;
      default:
        return '';
    }
  }

  return (
    <Section>
      {messageForStatus()}
      <div className="grid">
        <div className="col s4of5 half-spacing-top">
          <h1>{t('portfolio_promo_header')}</h1>

          <div style={{ marginRight: 50 }}>
            <p>{t('portfolio_promo_content')}</p>
            <span className="gutter-right">
              <Button
                disabled={status === 'sent' || status === 'sending'}
                primary
                text={t('portfolio_promo_yes_button_text')}
                onClick={send}
              />
            </span>
            <Button
              color="clear"
              icon="double-arrow-right"
              text={t('portfolio_promo_more_button_text')}
            />
          </div>
        </div>
        <div className="col s1of5 gutter-top">
          <img src={img} alt="risk" />
        </div>
      </div>
      <hr />
      {videoUrl && (
        <Flex justifyContent="center" alignItems="center">
          <ReactPlayer url={videoUrl} playing={false} />
        </Flex>
      )}
    </Section>
  );
}
